<script>
    import { TOKEN_SESSION, USER, TOAST_MESSAGE } from "../../stores"
    import { onMount } from "svelte";
    import { tweened } from 'svelte/motion';
    import { cubicOut } from 'svelte/easing';
    import Bars from "../Charts/Bars.svelte";
    import Pie from "../Charts/Pie.svelte";
    import GLOBALS from "../../globals/GLOBALS";
    import ReportSettings from "./ReportSettings.svelte";

    let REPORTES = null
    let setReport = null

    onMount(() => {
        _LIQ_QUERY("GETREPORTES",{rep_usu_id : $USER.usu_id})
    })

    const opacity = tweened(0, {
        duration: 2000,
        easing: cubicOut
    });

    const _LIQ_QUERY = async (QUERY, data) => {
        const URL = GLOBALS.URL;
        const bearer = "Bearer " + $TOKEN_SESSION;
        await fetch(`${URL}/API/reportes/QUERY/${QUERY}`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                Authorization: bearer,
                "Content-type": "application/json;charset=UTF-8",
            },
        })
            // Handle success
            .then((response) => response.json()) // convert to json
            .then((json) => {
                if (json.result === "success") {
                    switch (QUERY) {
                        case "GETREPORTES":
                            REPORTES = json.rows
                        break;
                    }
                } else {
                    TOAST_MESSAGE.set(json);
                    if (json.status === 403) TOKEN_SESSION.set(null)
                }
            }) //print data to console
            .catch((err) => -console.log("Request Failed", err)); // Catch errors
    };

    const _setReport = (item) => {
        setReport = item
        opacity.set(1)
    }

    const _closeSettings = () => {
        setReport = null
        opacity.set(0)
        _LIQ_QUERY("GETREPORTES",{rep_usu_id : $USER.usu_id})
    }

</script>

<div class="main-Reportes">
    <div class="title">Reportes y Gráficos</div>
    {#if !setReport}
        <div>
            <h1>Listado</h1>
            <div class="row">
                <div class="col-sm-12 col-md-6 offset-sm-3">
                    {#if REPORTES}
                        {#each REPORTES as item}
                            <div class="bullet-option d-flex flex-row justify-content-between align-items-center px-4"
                                on:click={() => _setReport(item)}
                            >
                                <div>{item.rep_descripcion}</div>
                                <ion-icon 
                                    class="color-false" 
                                    class:fav={item.fav_parametros === "" ? false : true} 
                                    class:shadow-inset={item.fav_parametros !== "" ? false : true} 
                                    name="star">
                                </ion-icon>
                            </div>
                        {:else}
                            <h3>nada</h3>
                        {/each}
                    {/if}
                </div>
            </div>
        </div>
        <!-- <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12 col-md-4 p-3">
                    <Bars
                        title={"Nuevo Título"}
                        data={[5, 10, 25, 36, 24, 23, 67]}
                        labels={[
                            "One",
                            "Two",
                            "three",
                            "Four",
                            "Five",
                            "Six",
                            "Seven",
                        ]}
                    />
                </div>
                <div class="col-sm-12 col-md-4 p-3">
                    <Pie
                        title={"Nuevo Título"}
                        data={[5, 10, 25, 67]}
                        labels={["One", "Two", "three", "Four"]}
                    />
                </div>
                <div class="col-sm-12 col-md-4 p-3">
                    <Pie
                        title={"Nuevo Título"}
                        data={[5, 10, 25, 67]}
                        labels={["One", "Two", "three", "Four"]}
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 p-3">
                    <Bars
                        title={"Nuevo Título"}
                        data={[5, 10, 25, 36, 24, 23, 67]}
                        labels={[
                            "One",
                            "Two",
                            "three",
                            "Four",
                            "Five",
                            "Six",
                            "Seven",
                        ]}
                    />
                </div>
                <div class="col-sm-12 col-md-4 p-3">
                    <Pie
                        title={"Nuevo Título"}
                        data={[5, 10, 25, 67]}
                        labels={["One", "Two", "three", "Four"]}
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 p-3">
                    <Bars
                        title={"Nuevo Título"}
                        data={[5, 10, 25, 36, 24, 23, 67]}
                        labels={[
                            "One",
                            "Two",
                            "three",
                            "Four",
                            "Five",
                            "Six",
                            "Seven",
                        ]}
                    />
                </div>
                <div class="col-sm-12 col-md-6 p-3">
                    <Bars
                        title={"Nuevo Título"}
                        data={[5, 10, 25, 67]}
                        labels={["One", "Two", "three", "Four"]}
                    />
                </div>
            </div>
        </div> -->
    {:else}
        <ReportSettings 
            report={setReport}
            opacity
            on:close={() => _closeSettings()}
        />
    {/if}
</div>

<style>
    .main-Reportes {
        display: flex;
        flex-direction: column;
        padding-top: 0;
        height: 100%;
        padding-bottom: 10px;
        overflow-y: auto;
    }

    .title {
        font-size: 3em;
        font-weight: bold;
        padding-right: 20px;
        text-align: right;
        border-bottom: 6px solid;
        color: #2c3e501f;
        line-height: 1;
        background-color: #fff;
    }

    .bullet-option {
        padding: 10px;
        text-align: center;
        cursor: pointer;
        background-color:#14518d33;
        color: #2c3e50;
        font-size: 1em;
        font-weight: bold;
        margin-bottom: 4px;
        border-radius: 40px;
        transition: all 250ms;
    }
    .bullet-option:hover {
        color:#fff;
        background-color: #2c3e50;
    }

    .color-false {
        color: #efefef;
    }

    .fav {
        color: #f1c40f !important;
        box-shadow: 0px 1px 4px 0px #00000030;
        border-radius: 50%;
    }
    
    .shadow-inset {
        box-shadow: inset 1px 1px 0px 0px #a1a1a1;
        border-radius: 50%;
    }
</style>
